<script setup lang="ts">
import useFinancingSystemType from '~/store-v2/financings/useFinancingSystemType'
import { isOnlyBattery } from '~/utils/project/systemType'

const props = defineProps<{
  projectId?: string
}>()

const { t } = useI18n()

// Same query key as the header (`HeaderBar`), so no extra request. While pending or on
// failure `data` is not `only_battery`, so the alert stays hidden.
const { data: systemType } = useFinancingSystemType(computed(() => props.projectId))

const showAlert = computed(() => isOnlyBattery(systemType.value))
</script>

<template>
  <SolAlert
    v-if="showAlert"
    id="only-battery-compatibility"
    class="my-4"
    feedback="informative"
    :title="t('header.project.only_battery.alert.title')"
  >
    {{ t('header.project.only_battery.alert.description') }}
  </SolAlert>
</template>
